import { gql } from '@apollo/client';

export default gql`
  mutation deleteTemplate($id: ID!) {
    deleteTemplate(input: { id: $id }) {
      success
    }
  }
`;
